/* ============================================================
   Custom Collection View — Son of Son
   1) View switcher (1-5 columnas) en sticky bar
   2) Filter mobile: convierte el modal del theme en un popover
      dropdown anclado al botón Filtrar (sin scroll-lock).
   ============================================================ */
(function () {
  'use strict';

  /* ---------- View switcher ---------- */
  const STORAGE_KEY_DESKTOP = 'sf:collection-view';
  const STORAGE_KEY_MOBILE = 'sf:collection-view-mobile';
  const VIEWS = ['1', '2', '3', '4', '5'];
  const MOBILE_BP = 768;
  const DESKTOP_DEFAULT = '5';
  const MOBILE_DEFAULT = '2';

  function svgFor(view) {
    const cols = parseInt(view, 10);
    const size = 22;
    const padding = 1;
    const gap = 1.5;
    const inner = size - padding * 2;
    const rows = cols === 1 ? 1 : cols;
    const cellW = (inner - gap * (cols - 1)) / cols;
    const cellH = (inner - gap * (rows - 1)) / rows;
    let cells = '';
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const x = padding + c * (cellW + gap);
        const y = padding + r * (cellH + gap);
        cells += '<rect x="' + x.toFixed(2) + '" y="' + y.toFixed(2) + '" width="' + cellW.toFixed(2) + '" height="' + cellH.toFixed(2) + '" rx="0.4" />';
      }
    }
    return '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' + cells + '</svg>';
  }

  function initViewSwitcher() {
    const sticky = document.querySelector('[data-collection-sticky-bar]');
    const products = document.querySelector('.collection__products');
    if (!sticky || !products || sticky.dataset.sfViewBound === '1') return;
    sticky.dataset.sfViewBound = '1';

    function isMobile() { return window.innerWidth < MOBILE_BP; }
    function storageKey() { return isMobile() ? STORAGE_KEY_MOBILE : STORAGE_KEY_DESKTOP; }
    function defaultView() { return isMobile() ? MOBILE_DEFAULT : DESKTOP_DEFAULT; }

    let saved = defaultView();
    try {
      const v = localStorage.getItem(storageKey());
      if (v && VIEWS.indexOf(v) !== -1) saved = v;
    } catch (e) {}

    const wrap = document.createElement('div');
    wrap.className = 'sf-view-switcher';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Cambiar vista');

    const buttons = {};
    VIEWS.forEach(function (v) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sf-view-switcher__btn';
      btn.dataset.view = v;
      btn.innerHTML = svgFor(v);
      btn.setAttribute('aria-label', 'Ver en ' + v + ' columnas');
      btn.addEventListener('click', function () { apply(v); });
      wrap.appendChild(btn);
      buttons[v] = btn;
    });

    const productsCount = sticky.querySelector('.collection__products-count');
    if (productsCount && productsCount.parentNode === sticky) {
      const toolbar = document.createElement('div');
      toolbar.className = 'sf-view-toolbar';
      sticky.insertBefore(toolbar, productsCount);
      toolbar.appendChild(wrap);
      toolbar.appendChild(productsCount);
    } else {
      sticky.appendChild(wrap);
    }

    function apply(view) {
      VIEWS.forEach(function (v) {
        products.classList.toggle('sf-view-' + v, v === view);
        buttons[v].classList.toggle('is-active', v === view);
      });
      try { localStorage.setItem(storageKey(), view); } catch (e) {}
    }

    apply(saved);

    let lastIsMobile = isMobile();
    window.addEventListener('resize', function () {
      const nowMobile = isMobile();
      if (nowMobile === lastIsMobile) return;
      lastIsMobile = nowMobile;
      let v = defaultView();
      try {
        const s = localStorage.getItem(storageKey());
        if (s && VIEWS.indexOf(s) !== -1) v = s;
      } catch (e) {}
      apply(v);
    });
  }

  /* ---------- Filter mobile como popover ---------- */
  /* Estrategia: parchear el prototype de <collection-filters> para que
     mobileFiltersScrollLock NO dispare theme:scroll:lock. Así la pagina
     conserva su scroll natural. La librería scroll-lock del theme nunca
     se activa, no hay que lidiar con touchmove preventDefault. */
  function patchCollectionFilters() {
    const ce = customElements.get('collection-filters');
    if (!ce || ce.__sfPatched) return false;
    ce.__sfPatched = true;

    /* Override: en mobile el "modal" se vuelve un popover anclado al
       sticky bar. NUNCA dispatcha theme:scroll:lock — la pagina mantiene
       su scroll natural. Aplica estilos inline directamente para ganar
       sobre cualquier CSS, también después de cada AJAX render.

       window.__sfClosingByUser: si el usuario está en proceso de cerrar
       (post-select), NO reabrir aunque el theme llame esta funcion al
       finalizar la AJAX. */
    ce.prototype.mobileFiltersScrollLock = function () {
      if (window.innerWidth >= 768 || !this.filters) return;
      if (window.__sfClosingByUser) return; /* respetar cierre del usuario */
      if (!this.filters.classList.contains('collection__filters--visible')) {
        this.filters.classList.add('collection__filters--visible');
      }
      applyOpenStyle(this.filters);
    };

    /* hideFiltersDrawer: solo quita la clase y aplica estilos cerrados.
       NO dispatcha theme:scroll:unlock (no es necesario porque nunca
       se locked). */
    ce.prototype.hideFiltersDrawer = function () {
      if (!this.filters) return;
      if (this.filters.classList.contains('collection__filters--visible')) {
        this.filters.classList.remove('collection__filters--visible');
        if (this.a11y && this.a11y.removeTrapFocus) this.a11y.removeTrapFocus();
      }
      if (window.innerWidth < 1024) applyClosedStyle(this.filters);
    };

    return true;
  }

  /* Defensive cleanup: si la librería scroll-lock del theme ya añadió
     atributos de bloqueo, los removemos. Se llama una sola vez al cargar
     y NO necesitamos un MutationObserver permanente porque el patch del
     prototype evita que vuelvan a aparecer. */
  function cleanupExistingLock() {
    document.documentElement.removeAttribute('data-scroll-locked');
    [document.body, document.documentElement].forEach(function (el) {
      Array.from(el.attributes).forEach(function (attr) {
        if (attr.name.indexOf('data-scroll-lock') === 0) {
          el.removeAttribute(attr.name);
        }
      });
    });
    if (window.scrollLock && typeof window.scrollLock.clearQueueScrollLocks === 'function') {
      try { window.scrollLock.clearQueueScrollLocks(); } catch (e) {}
      try { window.scrollLock.enablePageScroll(); } catch (e) {}
    }
  }

  /* Reubicar <collection-filters> al sticky bar para anclar el popover
     debajo del botón Filtrar. Solo en mobile (≤1023px). */
  function relocateFilters() {
    if (window.innerWidth >= 1024) return;
    const filters = document.querySelector('collection-filters.collection__filters, .collection__filters');
    const sticky = document.querySelector('[data-collection-sticky-bar]');
    if (!filters || !sticky) return;
    if (filters.parentNode === sticky) return;
    if (filters.dataset.sfRelocated === '1') return;
    filters.dataset.sfRelocated = '1';
    sticky.appendChild(filters);
  }

  /* Calcula el max-height disponible. Usa visualViewport.height en iOS
     (más preciso que innerHeight cuando la barra de URL está visible).
     Reserva 100px de buffer al fondo: ~50px para la URL bar + ~34px
     home indicator + 16px respiración. Si el contenido excede, el
     wrapper interno scrollea. */
  function computeMaxHeight(filters) {
    const rect = filters.getBoundingClientRect();
    const viewportH = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    const available = viewportH - rect.top - 100;
    return Math.max(260, Math.min(available, viewportH * 0.7));
  }

  /* Aplicar/quitar estilos inline cuando cambia la clase --visible.
     CSS externo no siempre gana por especificidad; inline + !important
     siempre gana. */
  function applyOpenStyle(filters) {
    const mh = computeMaxHeight(filters) + 'px';
    /* Outer: container sin scroll (clip durante la animación max-height) */
    filters.style.setProperty('max-height', mh, 'important');
    filters.style.setProperty('overflow', 'hidden', 'important');
    filters.style.setProperty('opacity', '1', 'important');
    filters.style.setProperty('pointer-events', 'auto', 'important');
    filters.style.setProperty('visibility', 'visible', 'important');
    /* Inner wrapper: aquí va el scroll. iOS Safari maneja scroll en
       elementos no-absoluteposed mucho mejor que en absolute.  */
    const wrapper = filters.querySelector('.collection__filters-wrapper');
    if (wrapper) {
      wrapper.style.setProperty('max-height', mh, 'important');
      wrapper.style.setProperty('overflow-y', 'auto', 'important');
      wrapper.style.setProperty('overflow-x', 'hidden', 'important');
      wrapper.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      wrapper.style.setProperty('touch-action', 'pan-y', 'important');
      wrapper.style.setProperty('overscroll-behavior', 'contain', 'important');
      wrapper.setAttribute('data-scroll-lock-scrollable', '');
    }
    filters.setAttribute('data-scroll-lock-scrollable', '');
  }
  function applyClosedStyle(filters) {
    filters.style.setProperty('max-height', '0', 'important');
    filters.style.setProperty('overflow', 'hidden', 'important');
    filters.style.setProperty('opacity', '0', 'important');
    filters.style.setProperty('pointer-events', 'none', 'important');
  }

  function bindFiltersStyleObserver() {
    if (window.innerWidth >= 1024) return;
    const filters = document.querySelector('.collection__filters');
    if (!filters || filters.dataset.sfStyleObs === '1') return;
    filters.dataset.sfStyleObs = '1';

    function sync() {
      if (filters.classList.contains('collection__filters--visible')) {
        applyOpenStyle(filters);
      } else {
        applyClosedStyle(filters);
      }
    }
    sync();

    if (window.MutationObserver) {
      new MutationObserver(sync).observe(filters, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  /* Click-outside para cerrar el popover (el modal del theme tenía un
     overlay clickable; lo escondemos con CSS, así que necesitamos esto). */
  function bindClickOutside() {
    if (window.__sfClickOutsideBound) return;
    window.__sfClickOutsideBound = true;
    document.addEventListener('click', function (e) {
      if (window.innerWidth >= 1024) return;
      const filters = document.querySelector('.collection__filters');
      const btn = document.querySelector('.collection__filters__toggle');
      if (!filters || !filters.classList.contains('collection__filters--visible')) return;
      if (filters.contains(e.target)) return;
      if (btn && btn.contains(e.target)) return;
      filters.classList.remove('collection__filters--visible');
      applyClosedStyle(filters);
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  /* Cerrar popover después de seleccionar una opción.
     Cerramos rapido (500ms post-change) y bloqueamos la reapertura del
     theme post-AJAX vía window.__sfClosingByUser durante 3s. */
  let closeTimer = null;
  let unblockTimer = null;
  function bindAutoCloseOnSelect() {
    if (window.__sfAutoCloseBound) return;
    window.__sfAutoCloseBound = true;
    document.addEventListener('change', function (e) {
      if (window.innerWidth >= 1024) return;
      const filters = document.querySelector('.collection__filters');
      if (!filters || !filters.classList.contains('collection__filters--visible')) return;
      if (!filters.contains(e.target)) return;
      if (closeTimer) clearTimeout(closeTimer);
      if (unblockTimer) clearTimeout(unblockTimer);
      /* Marcamos "cerrando" YA — si el theme corre mobileFiltersScrollLock
         entre ahora y el cierre, no reabre */
      window.__sfClosingByUser = true;
      closeTimer = setTimeout(function () {
        const f = document.querySelector('.collection__filters');
        const b = document.querySelector('.collection__filters__toggle');
        if (f) {
          f.classList.remove('collection__filters--visible');
          applyClosedStyle(f);
        }
        if (b) b.setAttribute('aria-expanded', 'false');
      }, 500);
      /* Después de 3s liberamos el flag — la AJAX ya termino para entonces
         y el usuario puede volver a abrir manualmente */
      unblockTimer = setTimeout(function () {
        window.__sfClosingByUser = false;
      }, 3000);
    });

    /* Click directo en el botón Filtrar limpia el flag inmediatamente —
       le da al usuario control instantáneo para reabrir tras cerrar. */
    document.addEventListener('click', function (e) {
      if (window.innerWidth >= 1024) return;
      const btn = e.target.closest('.collection__filters__toggle');
      if (!btn) return;
      window.__sfClosingByUser = false;
      if (closeTimer) clearTimeout(closeTimer);
      if (unblockTimer) clearTimeout(unblockTimer);
    }, true /* capture: corre antes que el handler del theme */);
  }

  /* Re-aplicar estilos cuando cambia el viewport (rotación, barra URL
     iOS aparece/oculta, etc). Si el popover está abierto, recalcular
     max-height. */
  function bindViewportRecalc() {
    if (window.__sfViewportRecalcBound) return;
    window.__sfViewportRecalcBound = true;
    const recalc = function () {
      const filters = document.querySelector('.collection__filters');
      if (!filters || !filters.classList.contains('collection__filters--visible')) return;
      applyOpenStyle(filters);
    };
    window.addEventListener('resize', recalc);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', recalc);
      window.visualViewport.addEventListener('scroll', recalc);
    }
  }

  /* Boot */
  function boot() {
    initViewSwitcher();
    relocateFilters();
    cleanupExistingLock();
    bindFiltersStyleObserver();
    bindClickOutside();
    bindAutoCloseOnSelect();
    bindViewportRecalc();

    /* El custom element collection-filters se define en filters.js que
       carga al final del body. Polling corto hasta que esté listo. */
    if (!patchCollectionFilters()) {
      let tries = 0;
      const iv = setInterval(function () {
        if (patchCollectionFilters() || ++tries > 60) clearInterval(iv);
      }, 50);
    }

    /* Re-relocate + re-observe después de Shopify section render */
    setTimeout(function () { relocateFilters(); bindFiltersStyleObserver(); }, 400);
    setTimeout(function () { relocateFilters(); bindFiltersStyleObserver(); }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
